<!--
 * @Author: gaozexiong RJgaozexiong@ruijie.com.cn
 * @Date: 2022-07-26 10:50:49
 * @LastEditors: gaozexiong RJgaozexiong@ruijie.com.cn
 * @LastEditTime: 2022-08-26 16:41:14
 * @FilePath: \ces-vue-serve\src\views\Finance\fundManagement.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <rj-tabs v-model="tabsActive">
      <rj-tab-pane name="1">
        <span slot="label">待审核来款错误</span>
        <waitError />
      </rj-tab-pane>
      <rj-tab-pane name="2">
        <span slot="label">已审核来款错误</span>
        <readyError />
      </rj-tab-pane>
    </rj-tabs>
  </div>
</template>

<script>
import tabs from '@/components/Tabs/tabs';
import tabPane from '@/components/Tabs/tabPane';
import waitError from './components/waitError.vue';
import readyError from './components/readyError.vue';
export default {
  components: {
    'rj-tab-pane': tabPane,
    'rj-tabs': tabs,
    waitError,
    readyError
  },
  data () {
    return {
      tabsActive: '1'
    };
  },
  computed: {},
  mounted () {},
  methods: {}
};
</script>

<style>

</style>
